import { Toast } from 'vant'

const DURATION = 3000
const MASK = true

export const loading = (message = '加载中...') => Toast.loading({
  mask: MASK,
  message,
  duration: 0,
})

export const toast = (message = '') => Toast({
  mask: false,
  message,
  duration: DURATION,
})

export const success = (message = '') => Toast.success({
  mask: MASK,
  message,
  duration: DURATION,
})

export const fail = (message = '') => Toast.fail({
  mask: MASK,
  message,
  duration: DURATION,
})
